import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';


const Schriftstellerei: React.FC = () => {

    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  
    const handleFacadeClick = () => {
      setIsVideoLoaded(true);
    };

  return (



  <div className="breadcrumbs">

    <Helmet>
    <title>Творчество - Сергей Мавроди: Стихи, Проза, Дневники, Песни</title>
    <meta
      name="description"
      content="Творчество Сергея Мавроди: стихи, проза ('Сын Люцифера', 'Дневники', 'Неделька'), киносценарии, песни и истории о тюрьме."
    />
    <meta name="keywords" content="Сергей Мавроди, творчество, стихи, Сын Люцифера, дневники, киносценарии, песни, тюрьма, Неделька" />
    <meta name="author" content="Сергей Мавроди" />
    <meta property="og:title" content="Творчество - Сергей Мавроди" />
    <meta
      property="og:description"
      content="Литературное творчество Сергея Мавроди: стихи, 'Сын Люцифера', 'Дневники', киносценарии, песни, 'Неделька' и истории о тюрьме."
    />
    <meta property="og:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:url" content="https://sergey-mavrodi.com/schriftstellerei" />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="ru_RU" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Творчество - Сергей Мавроди" />
    <meta
      name="twitter:description"
      content="Литературное творчество Сергея Мавроди: стихи, 'Сын Люцифера', 'Дневники', киносценарии, песни, 'Неделька' и истории о тюрьме."
    />
    <meta name="twitter:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <link rel="canonical" href="https://sergey-mavrodi.com/schriftstellerei" />
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'Творчество',
        'description': 'Раздел творчества Сергея Мавроди: стихи, проза ("Сын Люцифера", "Дневники", "Неделька"), киносценарии, песни и истории о тюрьме.',
        'url': 'https://sergey-mavrodi.com/schriftstellerei',
        'image': 'https://sergey-mavrodi.com/images/portrait.webp',
        'publisher': {
          '@type': 'Organization',
          'name': 'Сергей Мавроди',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            {
              '@type': 'ListItem',
              'position': 1,
              'name': 'Главная',
              'item': 'https://sergey-mavrodi.com/',
            },
            {
              '@type': 'ListItem',
              'position': 2,
              'name': 'Творчество',
              'item': 'https://sergey-mavrodi.com/schriftstellerei',
            },
          ],
        },
      })}
    </script>
  </Helmet>

    <div className="breadcrumb">
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → Творчество
      </div>
    </div>
    <div className="content">
      <div className="content_white_cloud">
        
        <div className="cwc_mid">
          <div className="content">
            <h2>ТВОРЧЕСТВО</h2>
           
           
            <div style={{ backgroundColor: 'rgb(220, 220, 220)', textAlign: 'center' }}>
            <p>&nbsp;</p>
            <div style={{ backgroundColor: 'white', marginLeft: '30px', marginRight: '30px' }}>
            <div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>

              <div style={{maxWidth: '531px', margin: '0 auto'}}>
                {!isVideoLoaded ? (
                  <div style={{borderRadius: '0'}}
                    onClick={handleFacadeClick}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => e.key === 'Enter' && handleFacadeClick()}
                    className="video-preview"
                  >
                    <img 
                      src="/video/Domen.avif"
                      alt="Домен"
                      className="video-thumbnail"
                      width="320"
                      height="240"
                    />
                    <svg
                      className="play-button"
                      fill="green"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                ) : (
                  <video style={{borderRadius: '0'}}
                    src="/video/Domen.mp4"
                    className="video-player"
                    controls
                    autoPlay
                    playsInline
                  />
                )}
              </div>

            <p style={{ margin: '0 0 0 0' }}>&nbsp;</p> 

<div style={{ backgroundColor: 'rgb(243, 243, 243)', marginLeft: '20px', marginRight: '20px' }}>

<strong><Link to="/schriftstellerei/gefangnis" className="yellow-underline" style={{ fontSize: '33px' }}>Тюрьма</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/gedichte" className="yellow-underline" style={{ fontSize: '33px' }}>Мои стихи</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>Сын Люцифера</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/tagebucher" className="yellow-underline" style={{ fontSize: '33px' }}>Дневники Сына Люцифера</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/drehbuch" className="yellow-underline" style={{ fontSize: '33px' }}>Киносценарии и Пьесы</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/lieder" className="yellow-underline" style={{ fontSize: '33px' }}>Песни / Песенки</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/schriftstellerei/woche" className="yellow-underline" style={{ fontSize: '33px' }}>Неделька</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/news/news12" className="yellow-underline" style={{ fontSize: '33px' }}>АРХИВ</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><a href="https://mavrobook.net/"
                  style={{fontSize: '33px',
                    textDecorationColor: 'rgb(255, 205, 0)',
                    textUnderlineOffset: '5px',
                    fontFamily: '"Times New Roman", "Times CY", "Nimbus Roman No9 L", serif'}}
                  aria-label="БИБЛИОТЕКА"
                  target="_blank"
                  rel="noopener noreferrer"
                >БИБЛИОТЕКА</a></strong>

</div>

<p>&nbsp;</p>
</div>
<p>&nbsp;</p>
</div> 
          </div>
        </div>
        
      </div>
    </div>
  </div>
);
};

export default Schriftstellerei;
